const APP_VERSION = '1784140027670';
export default APP_VERSION;
